import ConsumerIntegrationsListHeader from './ConsumerIntegrationsListHeader';

export default ConsumerIntegrationsListHeader;
